<template>
    <v-container fluid>
        <v-snackbar
            v-model="showSnackbar"
            :color="snackbarVariant"
            :timeout="3000"
            :top="'top'"
            absolute
            centered
            elevation="24"
            style="z-index: 9999"
        >
            <v-layout color="transparent" dark>{{ modalMessage }}</v-layout>
            <template v-slot:action="{ attrs }">
                <v-btn
                    dark
                    text
                    v-bind="attrs"
                    @click="showSnackbar = false"
                >
                    <i class="mdi mdi-close"></i>
                </v-btn>
            </template>
        </v-snackbar>

        <v-overlay :value="overlay" style="z-index: 2000;">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
</template>

<script>
import axios from "axios"
import _ from "lodash"
import { State, interpret } from "xstate"
import { toggleMachine } from "../../states/toggle"

export default {
    name: 'fortunepay',
    props: ['CheckIfLoggedInInternal'],
    metaInfo: {
        title: 'Digital Tuguegarao - Fortunepay'
    },
    data() {
        return {
            showSnackbar: false,
            snackbarVariant: 'red darken-3',
            modalMessage: '',
            overlay: false,
            token: null,
            fp_resp: null,
            redirect_url: '',
            callback_url: '',
            preset_id: '',
            citizen: {},
            paymentloaded: false,
            requestid: '',
            toggleService: interpret(toggleMachine),
            current: toggleMachine.initialState,
            context: toggleMachine.context,
            amounttopay: 0,
            transactiondescription: '',
            requestd: {},
        }
    },
    methods: {
        PaymentTime(){
            axios({
                method: 'post',
                url: `${this.domain}/fortunepay_payment`,
                data: {
                    token: this.token.toString(),
                    amount: this.amounttopay,
                    description: this.transactiondescription.toString(),
                }
            })
                .then(response => {
                    // console.log(response.data)
                    if(response.data.response){
                        // console.log(response.data)

                        this.preset_id = response.data.fp_resp.preset_id.toString()

                        // this.PaymentTime()
                        // https://devpaygate.fortunepay.com.ph/payment/index?merchant=a47c3ac930f6e41e585761553fc1b167&preset=4fe37d34328a9cc6b09e4a31eabcfa3e&ex_ref=873648723671237321
                        window.location = `https://devpaygate.fortunepay.com.ph/payment/index?merchant=${this.fp_resp.merchant_hash.toString()}&preset=${this.preset_id}&ex_ref=${response.data.code.toString()}`
                    } else{
                        this.showSnackbar = true
                        this.snackbarVariant = 'red darken-3'
                        this.modalMessage = response.data.message
                    }
                })
                .catch(() => {
                    this.showSnackbar = true
                    this.snackbarVariant = 'red darken-3'
                    this.modalMessage = `Something went wrong.. Try Again Later..`
                })
        },

        CallbackURL() {
            // console.log(this.requestd)

            if(this.requestd.request && this.requestd.request.linkid){
                // let callbacku = `${this.localdomain}fortunepay`

                // switch(this.requestd.request.division.toString()){
                //     case 'RPT':
                //         callbacku = `${this.localdomain}rptpayment`
                //         break;
                //     case 'BPLO':
                //         callbacku = `${this.localdomain}bplopayment`
                //         break;
                //     case 'CHISS':
                //         callbacku = `${this.localdomain}listofalltransactions`
                //         break;
                //     case 'RPTCLEARANCE':
                //         callbacku = `${this.localdomain}rptclearance`
                //         break;
                //     default:
                //         // return to dashboard
                //         this.$router.push({
                //             name: 'dashboard'
                //         }).catch(()=>{})
                //         break;
                // }

                axios({
                    method: 'post',
                    url: `${this.domain}/fortunepay_callbackurl`,
                    data: {
                        token: this.token.toString(),
                        url: `${this.domain}/fortunepay_callbackurl_params/${this.requestid}`,
                    }
                })
                    .then(response => {
                        if(response.data.response){
                            // console.log(response.data)

                            this.callback_url = response.data.fp_resp.callback_url.toString()
                            this.PaymentTime()
                        } else{
                            this.showSnackbar = true
                            this.snackbarVariant = 'red darken-3'
                            this.modalMessage = response.data.message
                        }
                    })
                    .catch(() => {
                        this.showSnackbar = true
                        this.snackbarVariant = 'red darken-3'
                        this.modalMessage = `Something went wrong.. Try Again Later..`
                    })
            }
        },

        RedirectURL() {
            if(this.requestd.request && this.requestd.request.linkid){
                axios({
                    method: 'post',
                    url: `${this.domain}/fortunepay_redirecturl`,
                    data: {
                        url: `${this.localdomain}paymentstatus/${this.requestid}/`,
                        token: this.token.toString(),
                    }
                })
                    .then(response => {
                        if(response.data.response){
                            console.log(response.data)

                            this.redirect_url = response.data.fp_resp.redirect_url.toString()

                            this.CallbackURL()
                        } else{
                            this.showSnackbar = true
                            this.snackbarVariant = 'red darken-3'
                            this.modalMessage = response.data.message
                        }
                    })
                    .catch(() => {
                        this.showSnackbar = true
                        this.snackbarVariant = 'red darken-3'
                        this.modalMessage = `Something went wrong.. Try Again Later..`
                    })
            }
        },

        Initialize() {
            this.overlay = true

            this.showSnackbar = true
            this.snackbarVariant = 'green darken-3'
            this.modalMessage = 'Accessing Fortunepay payment gateway. Please wait...'

            axios({
                method: 'post',
                url: `${this.domain}/fortunepay_login`,
                data: {
                    requestid: this.requestid.toString(),
                }
            })
                .then(response => {
                    if(response.data.response){
                        this.token = response.data.fp_resp.token.toString()
                        this.fp_resp = _.cloneDeep(response.data.fp_resp)

                        this.RedirectURL()
                    } else{
                        this.showSnackbar = true
                        this.snackbarVariant = 'red darken-3'
                        this.modalMessage = response.data.message
                    }
                })
                .catch(() => {
                    this.showSnackbar = true
                    this.snackbarVariant = 'red darken-3'
                    this.modalMessage = `Something went wrong.. Try Again Later..`
                })
        },

        paymentrequest() {
            this.overlay = true

            axios({
                method: 'post',
                url: `${this.domain}/op_payment_request`,
                data: {
                    id: this.requestid.toString(),
                }
            })
                .then(response => {
                    this.overlay = false

                    if(response.data.response){
                        const requestdata = this.$jwt.decode(response.data.request, this.jwtsecret)

                        // console.log(requestdata)
                        this.requestd = _.cloneDeep(requestdata)

                        if(requestdata.request.amount && parseFloat(requestdata.request.amount) > 0){
                            this.amounttopay = parseFloat(requestdata.request.amount)

                            switch(requestdata.request.division.toString().toUpperCase()){
                                case 'RPT': case 'BPLO': case 'CHISS':
                                    this.transactiondescription = `${requestdata.request.division.toString()} Payment for Transaction #${requestdata.request.paymentslip.toString()}`
                                    break;
                                case 'RPTCLEARANCE':
                                    this.transactiondescription = `${requestdata.request.division.toString()} Payment for TDN # (${requestdata.request.others.tdns.toString()})`
                                    break;
                            }

                            this.Initialize()
                        }
                    } else{
                        this.$emit('snackbar', {
                            variant: 'red darken-2',
                            message: response.data.message.toString(),
                        })
                    }
                })
                .catch(() => {
                    this.overlay = false
                })
        }
    },
    mounted() {
        this.CheckIfLoggedInInternal()
        // this.Initialize()
        const { user } = this.$jwt.decode(this.$session.get('crmusersessionsignature'), this.jwtsecret)
        user.mobile = user.mobile || ''
        delete user.passwd
        delete user.signature

        this.citizen = _.cloneDeep(user)

        // check
        this.CRM_Interval = setInterval(() => {
            if(!(this.$ls.get('isLoggedIn') && this.$session.exists() && this.$session.get('crmusersessionsignature'))){
                clearInterval(this.CRM_Interval)

                this.$router.push({
                    name: 'login'
                }).catch(()=>{})
            }
        }, 500)

        this.requestid = this.$route.params.requestid.toString()

        if(!this.requestid){
            this.$router.push({
                name: 'profile'
            }).catch(() => {})
        }

        this.paymentrequest()
    },
    created() {
        const stateDefinition = JSON.parse(localStorage.getItem('app-xstate')) || toggleMachine.initialState

        const previousState = State.create(stateDefinition)

        const resolvedState = toggleMachine.resolveState(previousState)

        this.toggleService
            .onTransition(state => {
                this.current = state
                this.context = state.context

                localStorage.setItem('app-xstate', JSON.stringify(state))
            })
            .start(resolvedState)
    },
}
</script>